export default __webpack_public_path__ + "static/soehne-breit-fett-ac125d1dc6a332b27a57b382f2632495.woff2";